import {DictionaryItem} from './dictionary.model';
import {GenericEntity} from './generic-entity.model';
import {Party} from './party.model';
import {Clause, GenericProductConfiguration, InsuredSubject} from './product.model';
import {PgPolicyVariant, PolicyCoAcquisition} from './policy.model';
import {SystemFile} from './system-file.model';
import {FilledQuestionnaire} from './questionnaire.model';

export class PgProductAvailableParams {
    sellTypes: boolean;
    productCount: number;
    paymentInstallment: boolean;
    outlet: boolean;
    leasing: boolean;
    salesDate: boolean;
    transcoder: boolean;
}

export class PgCalculationRequest {
    basicData: PgCalculationBasic;
    additionalData: PgCalculationAdditional;
    results: PgCalculationResult[];
    model?: string; // frontend only field
    questionnaire?: FilledQuestionnaire;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class PgCalculationBasic {
    sumInsured: number;
    assortmentIndex: string;
    assortmentGroup: DictionaryItem;
    assortmentSubgroup: DictionaryItem;
    brand: string;
    warranty: DictionaryItem;
}

export class PgCalculationAdditional {
    sellDate: string;
    sellType: DictionaryItem;
    paymentInstallment: boolean;
    leasing: boolean;
    outlet: boolean;
}

export class PgCalculationResult {
    productCode: string;
    productDescription: string;
    variantCode: string;
    variantDescription: string;
    premiumGross: number;
    owuNumber: string;
    owuHash: string;
    kidHash: string;
    warranty: number;
    enableModelList: boolean;
    enablePolicyNumber: boolean;
    productId: number;
    productUid: number;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class PgCreatePolicyRequest extends GenericEntity {
    basicData: PgCalculationBasic;
    additionalData: PgCalculationAdditional;
    selectedVariant: PgCalculationResult;
    insuranceSubjectModel: string;
    insuranceSubjectSerial: string;
    insuranceSubjectDescription: string;
    relatedPolicyNumber: string;
    purchaseDocumentNumber: string;
    purchaseType: DictionaryItem;
    promotion: boolean;
    policyholder: Party;
    clauses: Clause[];
    questionnaire?: FilledQuestionnaire;

    constructor(props = {}) {
        super(props);
        Object.assign(this, props);
    }
}

export class PgSalesConfiguration extends GenericProductConfiguration {
    clauses: Clause[];
    insuredSubject: InsuredSubject;
    coAcquisitions: PolicyCoAcquisition[];
    variant: PgPolicyVariant;
    printout: PgSalesConfigurationForPrintout;

    sellDate: string;
    sellType: DictionaryItem;
    paymentInstallment: boolean;
    promotion: boolean;
    leasing: boolean;
    outlet: boolean;
    relatedPolicyNumber: string;
    purchaseDocumentNumber: string;
    purchaseType: DictionaryItem;
    remoteSales: boolean;
}

export class PgSalesConfigurationForPrintout {
    owu: SystemFile;
    kid: SystemFile;
    readyPrintoutHash: string;
}
